import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Measurement, MeasurementContext, SiUnits, UnitType, UnitTypeDescriptions, UsUnits } from 'src/app/shared/data/engineering-enums';
import { ApiService } from 'src/app/shared/services/api.service';
import { EngineeringToolsApiService } from 'src/app/shared/services/engineering-tools-api';
import { UnitConverterService } from 'src/app/shared/services/unit-converter.service';
import { ToolBaseComponent } from '../tool-base';
import { MatDialog } from '@angular/material/dialog';
import { OrderStatusNoteComponent } from 'src/app/shared/components/order-status-notes/order-status-note/order-status-note.component';
import { CommentView } from 'src/app/shared/data/data.generated';

@Component({
  selector: 'app-oil-separator-calculation',
  templateUrl: './oil-separator-calculation.component.html',
  styleUrl: './oil-separator-calculation.component.scss',
  standalone: false
})
export class OilSeparatorCalculationComponent extends ToolBaseComponent {
  constructor(
    protected override hrtApi: ApiService,
    protected override api: EngineeringToolsApiService,
    protected override unitConverter: UnitConverterService,
    public dialog: MatDialog,
    private readonly route: ActivatedRoute,
  ) { 
    super(hrtApi, api, unitConverter);
    this.componentType = "OilSeparator";
  }

  ngOnInit() {
    this.initializeFromRouteIdOrCreate(this.route);
  }

  onChange(event: any, setCalculate: boolean = true) {
    this.updateComponent(setCalculate);
  }

  onCalculate() {
    this.viewModel.CalculateButton.Value = true;
    this.updateComponent(true);
  }

  formatVesselName(vessel: any): string {
    if (!vessel) {
      return '';
    }
    let typeName = '';
    switch (vessel.Layout) {
      case 0: typeName = 'Horizontal'; break;
      case 1: typeName = 'Horizontal (High Vel)'; break;
      case 2: typeName = 'Vertical'; break;
    }

    return vessel.Diameter.Value + '" - ' + typeName;
  }

  formatCoalescerName(coalescer: any): string {
    if (!coalescer) {
      return '';
    }
    let typeName = '';
    switch (coalescer.CoalescerType) {
      case 0: typeName = 'GL'; break;
      case 1: typeName = 'GL Long'; break;
      case 2: typeName = 'GLX'; break;
    }

    return typeName;
  }

  showCustomVessel: boolean = false;
  customVesselId: number = 0;
  customStandardVesselId: number = 0;
  customLength: Measurement = { Value: 0, Unit: UnitType.inches };
  customWallThickness: Measurement = { Value: 0, Unit: UnitType.inches };
  customOilLevel: Measurement = { Value: 0, Unit: UnitType.inches };
  customCoalescerId: number = 0;
  customCoalescerQuantity: number = 0;

  addNewCustomVessel(id: number = 14) {
    this.customVesselId = 0;
    this.customStandardVesselId = id;
    this.onStandardVesselChange(null);
    this.showCustomVessel = true;
  }

  onStandardVesselChange(event: any) {
    let vesselResult = this.viewModel.OutputViewModel.VesselOptions.Value.find((v: any) => v.Vessel.Id === this.customStandardVesselId && !v.IsCustom);
    if (vesselResult) {
      this.customLength = vesselResult.Length;
      this.customWallThickness = vesselResult.WallThickness;
      this.customOilLevel = vesselResult.OilLevel;
      this.customCoalescerId = vesselResult.Coalescer.Id;
      this.customCoalescerQuantity = vesselResult.CoalescerQuantity;
    }
  }

  deleteCustomVessel(id: number) {
    if (confirm("Are you sure you want to delete this custom vessel configuration?")) {
      var configString = this.viewModel.InputViewModel.CustomVesselConfigurations.Value;
      var configs = configString.split(';');
      var index = id - 1000;
      configs.splice(index, 1);
      this.viewModel.InputViewModel.CustomVesselConfigurations.Value = configs.join(';');
      this.onChange(null, false);
    }
  }

  editCustomVessel(id: number) { 
    var configString = this.viewModel.InputViewModel.CustomVesselConfigurations.Value;
    var configs = configString.split(';');
    var index = id - 1000;
    var config = configs[index];
    var parts = config.split(',');

    this.customVesselId = id;
    this.customStandardVesselId = parseInt(parts[0]);
    let vesselResult = this.viewModel.OutputViewModel.VesselOptions.Value.find((v: any) => v.Vessel.Id === this.customStandardVesselId && !v.IsCustom);
    this.customLength = parts[1] ? { Value: parseFloat(parts[1]), Unit: UnitType.inches } : vesselResult.Length;
    this.customWallThickness = parts[2] ? { Value: parseFloat(parts[2]), Unit: UnitType.inches } : vesselResult.WallThickness;
    this.customOilLevel = parts[3] ? { Value: parseFloat(parts[3]), Unit: UnitType.inches } : vesselResult.OilLevel;
    this.customCoalescerId = parts[4] ? parseInt(parts[4]) : vesselResult.Coalescer.Id;
    this.customCoalescerQuantity = parts[5] ? parseInt(parts[5]) : vesselResult.CoalescerQuantity;
    this.showCustomVessel = true;
  }

  saveCustomVessel() {
    let vesselResult = this.viewModel.OutputViewModel.VesselOptions.Value.find((v: any) => v.Vessel.Id === this.customStandardVesselId && !v.IsCustom);
    var configString = this.viewModel.InputViewModel.CustomVesselConfigurations.Value;
    var configs = configString ? configString.split(';') : [];
    var config = this.customStandardVesselId + ',' +
      (this.customLength.Value > 0 && vesselResult.Length !== this.customLength ? this.customLength.Value + ',' : ',') +
      (this.customWallThickness.Value > 0 && vesselResult.WallThickness !== this.customWallThickness ? this.customWallThickness.Value + ',' : ',') +
      (this.customOilLevel.Value > 0 && vesselResult.OilLevel !== this.customOilLevel ? this.customOilLevel.Value + ',' : ',') +
      (vesselResult.Coalescer.Id !== this.customCoalescerId ? this.customCoalescerId + ',' : ',') +
      (this.customCoalescerQuantity > 0 && vesselResult.CoalescerQuantity !== this.customCoalescerQuantity ? this.customCoalescerQuantity : '');
    if (this.customVesselId >= 1000) {
      var index = this.customVesselId - 1000;
      configs[index] = config;
    } else {
      configs.push(config);
    }
    this.viewModel.InputViewModel.CustomVesselConfigurations.Value = configs.join(';');
    this.onChange(null, false);
    this.showCustomVessel = false;
  }

  override getDefaultSaveName() : string {
    let id = this.viewModel.OutputViewModel.SelectedVesselId.Value;
    let vessel = this.viewModel.OutputViewModel.VesselOptions.Value.find((v: any) => v.Id === id);
    if (vessel)
      this.saveName = this.formatVesselName(vessel.Vessel) + (vessel.IsCustom ? ' (Custom)' : ' (Standard)');
    return this.saveName;
  }

  showNotes: boolean = false;
  comments: CommentView[] = []
  commentType: string = 'EngineeringToolSave';

  openNotes() {
    this.showNotes = true;
    this.comments = [];
    this.refreshCommentData();
  }

  addComment(newComment: string) {
    if (newComment == '') return;
    this.hrtApi.Feedback.AddFeedbackComment(this.loadId, newComment, this.commentType).subscribe((x) => {
      this.refreshCommentData();
    });
  }

  refreshCommentData() {
    this.hrtApi.EngineeringData.GetEngineeringToolSaveNotes(this.commentType, this.loadId).subscribe((x) => {
      this.comments = [];
      this.comments = x;
      this.comments = this.comments.reverse();
    });
  }
}